import { useTranslation } from 'react-i18next'
import { useParams, useSearchParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'

import { crudActionsMap } from 'utils/helpers'
import RtiRiskCriteriaOneForm from 'components/organisms/forms/RtiRiskCriteriaOneForm'
import { useGET_studentByIdQuery } from 'redux/api/studentsApi'

const RtiRiskCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const [searchParams] = useSearchParams();
  const student_id = searchParams.get('student_id')

  const { data: currentStudent } = useGET_studentByIdQuery(student_id, {skip: !student_id})

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  return (
    <>
      <PageHeading title={`${t('rti.identfiying-academic-risk')} / ${t('common.' + action)}`} />
      <PageBody>
        {(!student_id || currentStudent) && <RtiRiskCriteriaOneForm action={action} id={id} currentStudent={currentStudent} viewOnly={viewOnly} />}
      </PageBody>
    </>
  )
}
export default RtiRiskCrudPage
